module.exports = __webpack_public_path__ + "img/secondary.6c995ccc.svg";